<template>
  <ion-page>
    <ion-content color="primary" class="ion-padding verify-account-wrapper">
      <section class="verify-account-wrapper__body">
        <div class="verify-account-wrapper__logo ion-justify-content-center">
          <ion-img v-if="arriboLogo" :src="arriboLogo" alt="Arribo Logo"></ion-img>
        </div>
        <div class="verify-account-wrapper__hero ion-justify-content-center">
          <ion-img v-if="arriboHero" :src="arriboHero" alt="Arribo Hero"></ion-img>
        </div>
        <div
          v-if="!signUpSuccess"
          class="verify-account-wrapper__verify ion-justify-content-center"
        >
          <ion-row>
            <ion-col size="12">
              <ion-text
                class="ion-padding text-small text-align-center display-block"
                color="white"
              >
                {{ t('verifyAccount.title') }}
              </ion-text>
            </ion-col>
            <ion-col size="12">
              <ion-button
                data-test="submit"
                fill="clear"
                class="text-lg text-underline"
                color="white"
                expand="block"
                size="small"
                @click="goTo('welcome')"
              >
                {{ t('welcome.goToWelcome') }}
              </ion-button>
            </ion-col>
          </ion-row>
        </div>
      </section>
    </ion-content>
  </ion-page>
</template>
<script setup lang="ts">
  import { IonPage, IonImg, IonContent, IonText, IonButton, IonCol, IonRow } from '@ionic/vue';
  import arriboLogo from '@/assets/images/arribo-logo.svg';
  import arriboHero from '@/assets/images/arribo-hero.svg';

  import { useI18n } from 'vue-i18n';
  import { onMounted } from 'vue';
  import { useRoute } from 'vue-router';
  import { useSignUp } from '@/composables/useSignUp';
  import { useAuth } from '@/composables/useAuth';

  const { t } = useI18n();
  const route = useRoute();
  const { handleVerifyToken, signUpSuccess } = useSignUp();
  const { goTo } = useAuth();

  const initialConfig = async () => {
    if (route.query.token) {
      handleVerifyToken(route.query.token as string).then(() => {
        if (signUpSuccess.value) {
          goTo('onBoardingAbroad');
        }
      });
    }
  };

  onMounted(() => {
    initialConfig();
  });
</script>
<style scoped lang="scss">
  .verify-account-wrapper {
    position: relative;

    &__logo {
      position: absolute;
      top: 10%;
      width: 100%;
      display: flex;
      justify-content: center;

      ion-img {
        width: 190px;
      }
    }

    &__hero {
      position: absolute;
      top: 40%;
      width: 100%;
      display: flex;
      justify-content: center;

      ion-img {
        width: 85%;
      }
    }

    &__verify {
      position: absolute;
      bottom: 5%;
      width: 100%;
      display: flex;
      justify-content: center;
    }
  }

  @media screen and (min-width: 576px) {
  }

  @media screen and (min-width: 768px) {
  }

  @media screen and (min-width: 992px) {
  }

  @media screen and (min-width: 1200px) {
    .splash-wrapper {
      &__logo {
        position: absolute;
        top: 10%;
        width: 100%;
        display: flex;
        justify-content: center;

        ion-img {
          width: 190px;
        }
      }

      &__hero {
        position: absolute;
        top: 30%;
        width: 100%;
        display: flex;
        justify-content: center;

        ion-img {
          width: 55%;
        }
      }

      &__claim {
        position: absolute;
        bottom: 3%;
        width: 100%;
        display: flex;
        justify-content: center;
      }
    }
  }

  @media screen and (min-width: 1490px) {
  }
</style>
